import { browserLocalStorage } from "./browser-storage.ts";
import type { ApiRole } from "./api";

export type Locale = "sq" | "en";

export const translations = {
  sq: {
    productName: "eduBGT - Mësimi digjital",
    loginTitle: "Hyni në llogarinë tuaj",
    loginSubtitle: "Përdorni email-in e regjistruar në platformë për të vazhduar.",
    email: "Email",
    emailPlaceholder: "example@bgt.school",
    invalidEmail: "Shkruaj një email të vlefshëm.",
    checkingAccount: "Duke kontrolluar llogarinë...",
    securityCheck: "Kontroll sigurie",
    securityCheckFailed: "Kontrolli i sigurisë nuk përfundoi. Rifresko faqen dhe provo përsëri.",
    securityUnavailable: "Kontrolli i sigurisë nuk është i disponueshëm për momentin.",
    accountNotFound: "Llogaria nuk u gjet. Kontakto shkollën për qasje.",
    accountInactive: "Llogaria është joaktive. Kontakto shkollën.",
    schoolAccount: "Llogari e shkollës",
    schoolAccountText: "Do të vazhdosh me llogarinë tënde Microsoft 365.",
    externalAccount: "Llogari e autorizuar",
    externalAccountText: "Përdor fjalëkalimin e caktuar për këtë llogari.",
    externalInviteText: "Kur ta selektosh dhe klikosh “Dërgo ftesa”, do t’i dërgohet link për ta caktuar fjalëkalimin vetë.",
    password: "Fjalëkalimi",
    passwordPlaceholder: "Shkruaj fjalëkalimin",
    forgotPassword: "Harrove fjalëkalimin?",
    microsoftResetHint: "Rivendose përmes Microsoft",
    requestReset: "Dërgo link për reset",
    requestSent: "Nëse email-i ekziston në platformë, do të pranojë një link reset-i. Kontrollo inbox-in.",
    setPasswordTitle: "Cakto fjalëkalimin",
    setPasswordText: "Ky link është njëpërdorimësh. Zgjidh një fjalëkalim të fortë për llogarinë tënde.",
    setPasswordButton: "Ruaj fjalëkalimin",
    setPasswordSuccess: "Fjalëkalimi u ruajt. Tani mund të kyçesh.",
    passwordPolicyError: "Fjalëkalimi duhet të ketë së paku 8 karaktere, shkronjë të madhe, shkronjë të vogël, numër, simbol dhe pa hapësira.",
    passwordRulesTitle: "Fjalëkalimi duhet të përmbajë:",
    passwordRuleMinLength: "Së paku 8 karaktere",
    passwordRuleUppercase: "Një shkronjë të madhe",
    passwordRuleLowercase: "Një shkronjë të vogël",
    passwordRuleNumber: "Një numër",
    passwordRuleSymbol: "Një simbol",
    passwordRuleNoSpaces: "Pa hapësira",
    passwordSymbolsHint: "Mund të përdorni simbole si: ! @ # $ % ^ & * ? _ - + = . ,",
    checkingSession: "Duke kontrolluar sesionin",
    checkingSessionText: "Po verifikojmë nëse linku është ende aktiv.",
    sessionExpired: "Sesioni ka skaduar",
    sessionExpiredText: "Ky link nuk është më aktiv ose është përdorur më parë. Kërko një link të ri për të vazhduar.",
    requestAnotherLink: "Kthehu dhe kërko link të ri",
    confirmPassword: "Përsërit fjalëkalimin",
    passwordMismatch: "Fjalëkalimet nuk përputhen.",
    showPassword: "Shfaq fjalëkalimin",
    hidePassword: "Fshih fjalëkalimin",
    microsoft: "Vazhdo me Microsoft",
    signIn: "Kyçu në eduBGT",
    continue: "Vazhdo",
    signingIn: "Duke u kyçur...",
    accessOnly: "Qasja në eduBGT lejohet vetëm për përdoruesit e regjistruar.",
    contactLink: "Kontakto shkollën",
    callbackTitle: "Po e përfundojmë kyçjen",
    callbackText: "Llogaria jote po verifikohet në mënyrë të sigurt.",
    callbackError: "Kyçja nuk përfundoi",
    retry: "Kthehu te login",
    loading: "Duke u ngarkuar...",
    dashboard: "Përmbledhje",
    users: "Përdoruesit",
    userCategories: "Kategoritë e përdoruesve",
    staff: "Staf",
    addStaff: "Shto staf",
    addParent: "Shto prind",
    roles: "Rolet",
    studentsNav: "Nxënësit",
    studentCare: "Student Wellbeing",
    appearance: "Pamja e login-it",
    collapseSidebar: "Fsheh menynë",
    expandSidebar: "Shfaq menynë",
    studentCareModuleName: "Student Wellbeing",
    timetableModuleName: "eLearning",
    timetableTitle: "Orari i shkollës",
    timetableSubtitle: "Orari i importuar nga aSc Timetables — term1/2/3, javë A/B, ditë, orë, salla.",
    timetableImportButton: "Importo orarin (aSc XML)",
    timetableClearImported: "Fshi orarin e importuar",
    timetableClearConfirm: "Të fshihet orari i importuar, XML-të në pritje dhe profesorët/nxënësit e ardhur nga XML që ende nuk janë lidhur me user real?",
    timetableCleared: "U fshinë {count} hyrje të orarit. Llogaritë mbetën.",
    timetableRosterCleared: "U larguan {teachers} profesorë dhe {students} nxënës nga roster-i i XML që nuk ishin lidhur ende me user.",
    timetablePendingDiscarded: "U larguan {count} importe XML në pritje që nuk ishin pranuar ende.",
    timetableNothingToClear: "Nuk kishte orar, roster XML ose importe në pritje për t'u fshirë.",
    timetableImported: "Orari u importua: {entries} hyrje, {terms} terme të reja, {weeks} javë të reja.",
    timetableUnmatchedClasses: "Klasa pa përputhje",
    timetableUnmatchedSubjects: "Lëndë pa përputhje",
    timetableUnmatchedTeachers: "Profesorë pa përputhje",
    timetableNoRows: "XML-i nuk përmban hyrje orari.",
    timetableEmpty: "Ende s'ka orar. Importo një skedar aSc XML për ta parë këtu.",
    timetableTerm: "Termi",
    timetableWeek: "Java",
    timetableDay: "Dita",
    timetableClass: "Klasa",
    timetableSubject: "Lënda",
    timetableTeacher: "Profesori",
    timetableSlot: "Ora",
    timetableCreateAccounts: "Krijo llogari (për ata me email)",
    timetableSendInvites: "Dërgo ftesa pas krijimit",
    timetableDeactivateMissing: "Çaktivizo profesorët që s'janë në këtë XML",
    timetableImportHint: "Pranohet aSc XML ose JSON. Krijon regjistrin (klasa/lëndë/staf/nxënës), orarin dhe (opsionale) llogaritë — të gjitha këtu.",
    timetableAccountsCreated: "{count} llogari të reja",
    timetableInvited: "{count} ftesa",
    timetableAddManual: "Shto orë manualisht",
    timetableAddEntry: "Shto orën",
    timetableRoom: "Salla",
    timetableEdit: "Edito orarin",
    timetableEditEntry: "Edito orën",
    timetableActive: "Aktiv",
    timetableSave: "Ruaj orën",
    timetableEditRoom: "Edito sallën",
    timetableDuration: "min",
    timetableOnVacation: "Pushim",
    timetableVacationNoSchedule: "Orari nuk shfaqet gjate pushimit.",
    timetableSeed: "Krijo terme/javë bazë",
    timetableSeedHint: "Nuk ka ende terme/javë. Krijo strukturën bazë (Tremujori I–III, Javë A/B, Ora 1–7) për të shtuar orë manualisht.",
    timetableDeleteEntry: "Fshi orën",
    timetableTeachers: "Profesorët",
    timetableTeachersHint: "Çaktivizo profesorët që kanë lënë punën — orët e tyre fshihen nga orari pa u fshirë të dhënat.",
    timetableNoTeachers: "Nuk ka profesorë në orar.",
    timetableLessonsLabel: "orë",
    timetableStudents: "Nxënësit",
    timetableStudentsHint: "Çaktivizo nxënësit që kanë ikur nga shkolla — përjashtohen nga lista dhe eksportet pa u fshirë të dhënat.",
    timetableNoStudents: "Nuk ka nxënës.",
    timetableRosterAutosave: "Ndryshimet ruhen vetvetiu kur klikon kutizën — s'ka buton 'Ruaj'. Kutiza e zgjedhur = aktiv; e zbrazët = i çaktivizuar.",
    timetableStartDate: "Filloi",
    timetableEndDate: "U largua",
    timetableEnrolledDate: "Regjistruar",
    timetableLeftDate: "U largua",
    timetableLeaveBlocksLogin: "Data e largimit e bllokon kyçjen në platformë (te nxënësi bllokohet edhe prindi i lidhur).",
    classesTitle: "Klasat dhe nxënësit",
    classesText: "Klasat e importuara nga orari. Cakto kujdestarin, shiko nxënësit dhe transferoji mes paraleleve.",
    classesSchool: "Shkolla",
    classesHomeroom: "Kujdestari",
    classesNoHomeroom: "Pa kujdestar",
    classesStudentsLabel: "Nxënësit",
    classesStudentCount: "{count} nxënës",
    classesTransferTo: "Transfero te",
    classesNoClasses: "Nuk ka klasa. Importo orarin së pari.",
    classesNoStudents: "Nuk ka nxënës në këtë klasë.",
    classesTransferred: "Nxënësi u transferua.",
    classesHomeroomSaved: "Kujdestari u ruajt.",
    classesHomeroom2: "Kujdestari 2",
    classesNoAccount: "pa llogari",
    importSectionTitle: "Importo të dhënat",
    importSectionText: "Këtu caktohen vetëm kujdestarët e klasave. Importet e nxënësve me prindër dhe të stafit gjenden te Përdoruesit, në tab-in përkatës.",
    importStudentsTitle: "Nxënës + prindër",
    importStudentsHint: "Kolonat: First name; Last name; Class; Email; Gender; Father; Father - Email; Mother; Mother - Email; Legal guardian; Legal guardian - Email.",
    importStaffTitle: "Stafi",
    importStaffHint: "Kolonat: Title; First name; Last name; Gender; Email; Employed from; Employed till (data d/m/vvvv).",
    importClassTeachersTitle: "Kujdestarët e klasave",
    importClassTeachersHint: "Kolonat: Name/Abbreviation; Class teacher; Class teacher 2. Cakton deri në 2 kujdestarë për klasë.",
    importChooseCsv: "Zgjidh CSV",
    importStudentsCount: "nxënës",
    importGuardiansCount: "prindër të ruajtur",
    importLinkedCount: "lidhje",
    importAccountsCount: "llogari të reja",
    importStaffCount: "staf",
    importBlockedCount: "të bllokuar",
    importAssignedCount: "klasa me kujdestarë",
    importUnmatchedCount: "të papërputhura",
    genDayMon: "E hënë",
    genDayTue: "E martë",
    genDayWed: "E mërkurë",
    genDayThu: "E enjte",
    genDayFri: "E premte",
    elearningComingSoon: "LMS-ja e shkollës (materiale, mësime, detyra) është në zhvillim dhe vjen së shpejti.",
    refresh: "Rifresko",
    assessmentTitle: "Testet",
    assessmentSubtitle: "Krijo teste/kuize me pyetje, të lidhura me lëndët dhe klasat e shkollës.",
    assessmentTitlePlaceholder: "Titulli i testit",
    assessmentSubject: "Lënda",
    assessmentClass: "Klasa",
    assessmentCreate: "Krijo test",
    assessmentCreated: "Testi u krijua.",
    assessmentEmpty: "Ende s'ka teste. Krijo një të ri.",
    assessmentQuestionsLabel: "pyetje",
    assessmentPointsLabel: "pikë",
    assessmentSelectHint: "Zgjidh një test për të menaxhuar pyetjet.",
    assessmentStatusDraft: "Draft",
    assessmentStatusPublished: "Publikuar",
    assessmentStatusClosed: "Mbyllur",
    assessmentDelete: "Fshi testin",
    assessmentDeleteQuestion: "Fshi pyetjen",
    assessmentPoints: "Pikë",
    assessmentPromptPlaceholder: "Shkruaj pyetjen…",
    assessmentOption: "Opsioni",
    assessmentRemoveOption: "Hiq opsionin",
    assessmentAddOption: "Shto opsion",
    assessmentExpectedAnswer: "Përgjigjja e pritur (opsionale)",
    assessmentAddQuestion: "Shto pyetje",
    assessmentQuestionSaved: "Pyetja u ruajt.",
    assessmentTypeSingle: "Një përgjigje",
    assessmentTypeMultiple: "Disa përgjigje",
    assessmentTypeShort: "Përgjigje e shkurtër",
    assessmentTypeLong: "Përgjigje e gjatë",
    assessmentTake: "Provo testin",
    assessmentTaking: "Duke marrë testin",
    assessmentSubmit: "Dorëzo",
    assessmentScore: "Rezultati",
    assessmentResults: "Rezultatet",
    assessmentNoResults: "Ende pa tentativa.",
    assessmentStudent: "Nxënësi",
    assessmentYourAnswer: "Përgjigjja jote",
    assessmentClose: "Mbyll",
    studentCareMemberTitle: "Student Wellbeing",
    studentCareMemberText: "Plotëso një referim të ri dhe shih listën e referimeve të dërguara. Detajet konfidenciale mbeten të mbyllura derisa Student Adviser t'i ndajë me ju.",
    studentCareCounselorText: "Shih referimet hyrëse nga profesorët, filtro rastet sipas urgjencës dhe ndiq shënimet e raportuara për secilin nxënës.",
    studentCarePrivacyTitle: "Referim privat",
    studentCarePrivacyText: "Profesori mund të shohë vetëm listën e referimeve të dërguara. Të dhënat konfidenciale dhe raporti i rastit mbeten të mbyllura derisa Student Adviser t'i ndajë me ju.",
    referralFormTitle: "Referim për Mbështetje",
    referralFormText: "Plotësoni informacionet e nevojshme për të referuar një nxënës te Student Adviser.",
    referralBreadcrumbNew: "Referim i ri",
    referralStudent: "Nxënësi",
    referralStudentPlaceholder: "Zgjidh nxënësin",
    referralGradeClass: "Klasa",
    referralGradeClassHint: "Plotëso klasën nëse nuk është e disponueshme automatikisht.",
    referralTeacher: "Profesori",
    referralDateTime: "Data dhe ora",
    referralAcademic: "Akademike",
    referralSocialEmotional: "Sociale / Emocionale",
    referralNotes: "Shënime shtesë (opsionale)",
    referralNotesPlaceholder: "Shkruani shënime shtesë rreth situatës së nxënësit...",
    referralUrgency: "Urgjenca",
    referralUrgencyLow: "E ulët",
    referralUrgencyMedium: "Mesatare",
    referralUrgencyHigh: "E lartë",
    referralSubmit: "Dërgo referimin",
    referralCancel: "Anulo",
    referralSuccess: "Referimi u dërgua me sukses. Ky informacion është privat dhe i qasshëm vetëm nga Student Adviser.",
    referralConfirmTitle: "Konfirmo dërgimin e referimit",
    referralConfirmText: "A dëshiron ta dërgosh këtë referim?",
    referralFormMinimized: "Forma është minimizuar derisa po shikon raportet e dërguara.",
    referralStatusChanged: "Statusi i një raporti ndryshoi",
    referralNoStudents: "Nuk ka nxënës aktivë për përzgjedhje.",
    referralLoadingStudents: "Duke ngarkuar nxënësit...",
    referralValidation: "Zgjidh nxënësin, plotëso klasën dhe së paku një arsye referimi.",
    referralSubmittedTitle: "Raportet e dërguara",
    referralSubmittedText: "Raportet tuaja ruhen në mënyrë konfidenciale. Mund të shihni listën e referimeve që keni dërguar, por detajet do të jenë të mbyllura derisa Student Adviser t'i ndajë me ju.",
    referralAccessTitle: "Qasje në raportet e dërguara",
    referralAccessText: "Për të hapur raportet e dërguara, vazhdo me Microsoft. Pa verifikim raportet mbeten të mbyllura.",
    referralAccessOpen: "Shfaq raportet",
    referralSearchPlaceholder: "Kërko sipas referimit...",
    referralFilter: "Filtra",
    referralFilterAll: "Të gjitha urgjencat",
    referralColumnDateTime: "Data dhe ora",
    referralColumnStudent: "Nxënësi",
    referralColumnClass: "Klasa",
    referralColumnLevel: "Niveli",
    referralColumnStatus: "Statusi",
    referralLockedTitle: "Të dhëna konfidenciale",
    referralLockedText: "Detajet do të ndahen me ju nga Student Adviser.",
    counselorInboxTitle: "Referimet hyrëse",
    counselorInboxText: "Këtu shfaqen të gjitha referimet që profesorët kanë dërguar për mbështetje.",
    counselorStatNew: "Të reja",
    counselorStatReview: "Në shqyrtim",
    counselorStatScheduled: "Të planifikuara",
    counselorTeacher: "Profesori",
    counselorStudent: "Nxënësi",
    counselorReasons: "Arsyet",
    counselorReferredBy: "Referuar nga profesori",
    counselorNotes: "Shënimet",
    counselorNoNotes: "Nuk ka shënime shtesë.",
    counselorActions: "Veprime",
    counselorDownloadPdf: "Shkarko PDF",
    counselorNotifyParent: "Cakto takim me prindin",
    counselorNotifyingParent: "Duke caktuar...",
    counselorParentNotified: "Takimi me prindin u caktua dhe prindi u njoftua me email.",
    counselorParentEmailMissing: "Shto email-in e prindit te profili i nxënësit.",
    counselorParentMeetingHint: "Cakto datën dhe orën e takimit me prindin.",
    counselorSendParentNotice: "Cakto takimin",
    counselorMarkReview: "Shëno si në shqyrtim",
    counselorAcceptReferral: "Prano referimin",
    counselorScheduleMeeting: "Planifiko takim",
    counselorScheduleStudent: "Nxënësi",
    counselorScheduleDate: "Data",
    counselorScheduleTime: "Ora",
    counselorSaveMeeting: "Cakto takimin",
    counselorMeetingScheduled: "Takimi u caktua me sukses.",
    counselorDirectMeeting: "Cakto takim",
    counselorDirectMeetingText: "Cakto një takim direkt me një nxënës.",
    counselorSelectStudent: "Zgjidh nxënësin",
    counselorNotifications: "Njoftime",
    counselorNoNotifications: "Nuk ka njoftime të reja.",
    counselorCalendar: "Kalendari i takimeve",
    counselorCalendarYesterday: "Dje",
    counselorCalendarToday: "Sot",
    counselorCalendarTomorrow: "Nesër",
    counselorFullCalendar: "Kalendari i plotë",
    counselorFullCalendarTitle: "Kalendari mujor i takimeve",
    counselorFullCalendarHint: "Ditët me pikë kanë takime me prindër, nxënës ose referime.",
    counselorFullCalendarLegend: "takime",
    counselorFullCalendarClose: "Mbyll kalendarin",
    counselorMeetingWith: "Takimi me",
    counselorMeetingTypeStudent: "Takim me nxënësin",
    counselorMeetingTypeParent: "Takim me prindin",
    counselorMeetingParentOf: "Prindi i",
    counselorRepeat: "Përsëritja",
    counselorRecurDays: "Ditët e javës",
    counselorRecurMonths: "Për sa muaj",
    counselorRecurHint: "Zgjidh ditët dhe muajt për takim të përsëritur (lëri pa zgjedhur për një takim të vetëm).",
    counselorRepeatCreated: "U caktuan {count} takime.",
    counselorRepeatPartial: "U caktuan {created} takime; {skipped} u anashkaluan (orë e zënë).",
    advisoryTitle: "Raport për profesorët",
    advisoryHint: "Dërgo një raport te të gjithë profesorët për një nxënës (p.sh. fushat ku është më i ndjeshëm).",
    advisoryReasons: "Arsyet",
    advisoryContentPlaceholder: "Shkruaj raportin për profesorët (p.sh. nxënësi është më i ndjeshëm te...)",
    advisorySend: "Dërgo raportin",
    advisorySending: "Duke dërguar...",
    advisorySent: "Raporti u dërgua te profesorët.",
    advisoryListTitle: "Raportet e dërguara",
    advisoryEmpty: "Ende nuk ke dërguar raporte.",
    advisoryDelete: "Fshij",
    advisoryConfirmDelete: "Ta fshij këtë raport?",
    professorAdvisoriesTitle: "Raporte nga psikologu",
    professorAdvisoriesHint: "Raporte nga psikologu i shkollës për nxënësit.",
    professorAdvisoriesEmpty: "Nuk ka raporte nga psikologu.",
    advisoryFrom: "Nga",
    intakeTitle: "Nxënësit e rinj",
    intakeHint: "Ruaj raporte për nxënësit që do të fillojnë shkollën (para regjistrimit në sistem).",
    intakeStudentName: "Emri i nxënësit",
    intakeStudentNamePlaceholder: "Emri dhe mbiemri",
    intakeGradeClass: "Klasa (opsionale)",
    intakeContentPlaceholder: "Shkruaj raportin për nxënësin e ri...",
    intakeSave: "Ruaj raportin",
    intakeSaving: "Duke ruajtur...",
    intakeSaved: "Raporti u ruajt.",
    intakeListTitle: "Raportet e ruajtura",
    intakeEmpty: "Ende nuk ke ruajtur raporte.",
    intakeViewReport: "Shiko raportin",
    intakeHideReport: "Mbyll raportin",
    intakeConfirmDelete: "Ta fshij këtë raport?",
    counselorMeetingParentUnknown: "Prind (emri pa regjistruar)",
    counselorNoAppointments: "Nuk ka takime për këtë datë.",
    counselorNextAppointment: "Takimi i radhës",
    counselorNoUpcomingAppointment: "Nuk ka takim të ardhshëm.",
    counselorThisMonth: "Këtë muaj",
    counselorCompletedCases: "Të përfunduara",
    counselorHighPriority: "Prioritet i lartë",
    counselorReschedule: "Riplanifiko",
    counselorCancelMeeting: "Anulo takimin",
    counselorPrivateNotes: "Shënime private",
    counselorPrivateNotesHint: "Vetëm ju mund t'i shihni këto shënime.",
    counselorAddNote: "Shto shënim",
    counselorHistory: "Historia e rastit",
    counselorStatusFilter: "Të gjitha statuset",
    counselorClassFilter: "Të gjitha klasat",
    counselorCloseReferral: "Mbyll referimin",
    counselorCompleteReferral: "Shëno si të përfunduar",
    counselorCompleteMessageHint: "Lër një mesazh për profesorin që e dërgoi referimin (opsionale).",
    counselorCompleteMessagePlaceholder: "Mesazhi për profesorin…",
    counselorCompleteAndSend: "Përfundo dhe dërgo",
    professorCounselorMessage: "Mesazhi nga psikologu i shkollës",
    counselorNewReferral: "Referim i ri",
    counselorTodayReferrals: "Referimet e sotme",
    counselorOldReferrals: "Referimet e vjetra",
    counselorFilterDate: "Kërko sipas datës",
    referralStatusSent: "Dërguar",
    referralStatusPending: "Në pritje",
    referralStatusInReview: "Në shqyrtim",
    referralStatusShared: "Ndarë",
    referralStatusClosed: "Mbyllur",
    referralStatusCompleted: "Përfunduar",
    referralNoResults: "Nuk ka referime të dërguara ende.",
    welcome: "Mirë se erdhe",
    workspaceText: "Menaxho qasjen, rolet dhe identitetin vizual të eduBGT.",
    role: "Roli",
    logout: "Dil",
    sessionSecurity: "Siguria e sesionit",
    loginSessionExpired: "Sesioni ka skaduar për sigurinë e llogarisë. Kyçu përsëri për të vazhduar.",
    sessionExpiresSoon: "Sesioni do të skadojë së shpejti",
    sessionExpiresSoonText: "Nuk është regjistruar aktivitet për 25 minuta. Vazhdo sesionin brenda 5 minutave ose do të kthehesh automatikisht në login.",
    continueSession: "Vazhdo sesionin",
    totalUsers: "Përdorues gjithsej",
    activeUsers: "Llogari aktive",
    admins: "Adminë",
    professors: "Profesorë",
    students: "Nxënës",
    parents: "Prindër",
    accessOverview: "Qasja në eduBGT",
    accessOverviewText: "Çdo përdorues regjistrohet paraprakisht. Email-at @bgt.school përdorin Microsoft; domain-et tjera përdorin fjalëkalim.",
    microsoftAccess: "Microsoft 365",
    passwordAccess: "Email + fjalëkalim",
    protectedAccess: "Qasje e kontrolluar",
    userDirectory: "Lista e përdoruesve",
    userDirectoryText: "Menaxho stafin, nxënësit dhe prindërit në një vend. Një përdorues mund të ketë disa role.",
    studentDirectory: "Lista e nxënësve",
    studentDirectoryText: "Ruaj nxënësit bazë që profesorët t'i përzgjedhin te referimet e Student Wellbeing.",
    parentEmail: "Email-i i prindit",
    parentEmailPlaceholder: "prindi@example.com",
    saveParentEmail: "Ruaj email-in e prindit",
    parentEmailSaved: "Email-i i prindit u ruajt.",
    parentName: "Emri i prindit",
    parentNamePlaceholder: "Emri dhe mbiemri i prindit",
    parentNameSaved: "Emri i prindit u ruajt.",
    gradeClass: "Klasa",
    subjectsTaught: "Lëndët",
    addStudent: "Shto nxënës",
    createStudent: "Krijo nxënësin",
    newStudentTitle: "Nxënës i ri",
    newStudentText: "Ruaj emrin, mbiemrin dhe email-in e nxënësit për ta përdorur te referimet.",
    firstName: "Emri",
    lastName: "Mbiemri",
    noStudentsSaved: "Nuk ka nxënës të ruajtur ende.",
    studentCreated: "Nxënësi u krijua me sukses.",
    accessPolicyTitle: "Rregulli i qasjes",
    accessPolicyText: "Login-i lejohet vetëm për llogari që ekzistojnë këtu dhe janë aktive.",
    accessPolicyMicrosoft: "@bgt.school përdor Microsoft 365 pasi të regjistrohet në dashboard.",
    accessPolicyLocal: "Domain-et tjera marrin link aktivizimi dhe përdorin fjalëkalim lokal.",
    accessPolicyActive: "Llogaritë joaktive dhe email-at e paregjistruar refuzohen para kyçjes.",
    searchUsers: "Kërko me emër ose email",
    addUser: "Shto përdorues",
    importUsers: "Import",
    importUsersTitle: "Importo përdorues dhe të dhëna për eLearning",
    importUsersText: "Këtu importohen vetëm llogari me email (CSV/Excel). Orarin (XML nga aSc) importoje te Konfigurimet → Orari.",
    usersImportHint: "Këtu importohen vetëm llogari me email (CSV/Excel). Orarin (XML) importoje te Konfigurimet → Orari.",
    chooseImportFile: "Zgjidh CSV ose Excel",
    importContent: "Përmbajtja e importit",
    importPlaceholder: "CSV/Excel: first_name,last_name,email,children",
    csvImportMode: "CSV/Excel për prindër ose përdorues",
    xmlImportMode: "XML staging për eLearning",
    csvImportHelp: "CSV/Excel krijon vetëm emër, mbiemër dhe email. Kolona Children mund të përdoret për lidhje automatike ose pending me nxënësit nga XML.",
    xmlImportHelp: "XML ruan nxënës, klasa, profesorë, lëndë dhe orar për eLearning. Nëse aktivizohet opsioni më poshtë, krijon edhe llogari globale për nxënësit/profesorët që kanë email (ata pa email ruhen vetëm në roster — për t'u dhënë email më vonë, shkarko listën më poshtë, mbush email-at dhe riimporto si CSV). Pranohet edhe formati i eksportit <users>.",
    xmlStatsLine: "XML: {students} nxënës, {teachers} profesorë, {classes} klasa, {subjects} lëndë u ruajtën për eLearning.",
    createAccountsFromXml: "Krijo llogari nga XML (për ata me email)",
    rosterPendingTitle: "Pa llogari (nga orari)",
    rosterPendingHint: "Profesorë/nxënës nga orari pa llogari. Shkarko listën, plotëso email-at, ngarko përsëri ose regjistro manualisht. Për nxënësit, lista ka edhe kolona për baba/nënë/kujdestar (+ gjinia) — plotëso email-in e nxënësit dhe të prindit në të njëjtin rresht dhe lidhen automatikisht kur ngarkohet. Ky import pranon edhe eksportin CSV të EduPage direkt (First name/Last name/Class/Father - Gender/... etj.) — mund ta ngarkosh ashtu si është, pa e riformatuar.",
    rosterTeacher: "Profesor",
    rosterStudent: "Nxënës",
    rosterSendInviteWhenEmail: "Dërgo ftesë (kur ka email)",
    rosterSendInviteGuardians: "Dërgo ftesë edhe prindërve/kujdestarëve (i veçantë nga nxënësit)",
    rosterSearchName: "Kërko emër",
    rosterRoleAll: "Të gjithë",
    rosterRoleTeachers: "Profesorë",
    rosterRoleStudents: "Nxënës",
    rosterEmailAll: "Të gjitha",
    rosterOnlyWithEmail: "Vetëm me email",
    rosterSendInvitesCount: "Dërgo ftesa ({count})",
    rosterEmptyFilter: "S'ka njerëz për këtë filtër.",
    rosterRegistered: "{name} u regjistrua.",
    rosterAlreadyExisted: "{name} kishte llogari — u lidh me regjistrin (nuk u krijua llogari e re).",
    rosterBulkExisting: "({existing} kishin tashmë llogari, u lidhën.)",
    rosterBulkRegistered: "U regjistruan {registered}.",
    rosterBulkRegisteredInvited: "U regjistruan {registered}, u dërguan {invited} ftesa.",
    rosterRegister: "Regjistro",
    rosterManageAtUsers: "Llogaritë menaxhohen te Përdoruesit → Pa llogari (nga orari).",
    rosterDownloadExcel: "Shkarko Excel",
    rosterUploadFilled: "Ngarko Excel të plotësuar",
    rosterFillResult: "U përputhën {matched}, u krijuan {created}, u dërguan {invited} ftesa.",
    rosterFillGuardianNote: "Prindër: {stored} u ruajtën, {linked} u lidhën automatikisht me nxënësit.",
    rosterUploadProcessing: "Duke përpunuar rreshtat, mos e mbyll faqen — mund të zgjasë disa dhjetëra sekonda për shumë rreshta.",
    uploadInProgress: "Duke ngarkuar e përpunuar skedarin, mos e mbyll faqen…",
    rosterUnmatched: "Pa përputhje",
    rosterSuspiciousNames: "Emra dyshimtë prindërish (numra në vend të emrit — kontrollo CSV-në burimore)",
    rosterSelectAll: "Zgjidh të gjithë",
    rosterRegisterSelected: "Regjistro të zgjedhurit ({count})",
    rosterFilterClass: "Filtro klasën",
    rosterFilterRole: "Filtro rolin",
    rosterOnlyNoEmail: "Vetëm pa email",
    exportUsers: "Eksporto",
    rosterNeedEmail: "Shkruaj email-in",
    downloadRosterTemplate: "Shkarko listën nga orari (pa llogari)",
    rosterTemplateHelp: "Shkarko të gjithë nxënësit/profesorët nga orari që s'kanë ende llogari (email-at ekzistues vijnë të mbushur), plotëso ato që mungojnë në Excel, dhe riimporto si CSV (me 'Dërgo ftesa') për t'i krijuar e ftuar llogaritë.",
    sendInvitesAfterImport: "Dërgo ftesa/udhëzime pas importit",
    importCompleted: "Importi përfundoi",
    createdShort: "të krijuar",
    updatedShort: "të përditësuar",
    linkedShort: "lidhje",
    pendingShort: "pending",
    stagedShort: "staging",
    invitedShort: "ftesa",
    skippedShort: "të anashkaluar",
    invitePolicyTitle: "Si funksionojnë ftesat",
    invitePolicyText: "Krijimi i përdoruesit vetëm e regjistron në platformë. Email-i dërgohet vetëm kur e selekton dhe klikon “Dërgo ftesa”, ose kur e aktivizon checkbox-in gjatë importit.",
    invitePolicyAutomatic: "Krijimi manual nuk dërgon email automatikisht.",
    invitePolicyMicrosoft: "@bgt.school nuk merr link aktivizimi/password; merr vetëm njoftim dhe kyçet me Microsoft.",
    invitePolicyLocal: "Email-at jashtë domain-it marrin link për të krijuar fjalëkalimin.",
    invitePolicySelection: "Butoni “Dërgo ftesa” punon vetëm për përdoruesit e selektuar.",
    allUsers: "Krejt",
    linkParentStudent: "Lidh prind-nxënës",
    linkParentStudentText: "Përdor kërkimin dhe tabelat për lista të mëdha. Mund ta lidhësh një prind me disa nxënës, ose një nxënës me disa prindër/kujdestarë.",
    linkModeParentToStudents: "Prind → nxënës",
    linkModeStudentToParents: "Nxënës → prindër",
    linkDialogHint: "Për 300+ përdorues mos kërko me sy në listë; shkruaj emrin, mbiemrin ose email-in dhe selekto rreshtat që duhen lidhur.",
    chooseParentFirst: "Zgjidh prindin / kujdestarin",
    chooseStudentFirst: "Zgjidh nxënësin",
    selectStudentsToLink: "Selekto nxënësit",
    selectParentsToLink: "Selekto prindërit / kujdestarët",
    linkedCount: "Lidhje",
    selectedCount: "{count} të selektuar",
    showingCount: "{shown} nga {total}",
    alreadyLinked: "E lidhur",
    newLinkLabel: "E re",
    readyLinks: "Lidhje të reja për ruajtje",
    saveLinks: "Ruaj lidhjet",
    linksSaved: "U ruajtën {count} lidhje.",
    noNewLinks: "Zgjidh të paktën një lidhje të re.",
    selectParentAndStudents: "Zgjidh një prind/kujdestar dhe së paku një nxënës.",
    selectStudentAndParents: "Zgjidh një nxënës dhe së paku një prind/kujdestar.",
    parentGuardianEmail: "Prindi / kujdestari",
    studentEmail: "Nxënësi",
    searchParentGuardian: "Kërko prindin me emër ose mbiemër",
    searchStudent: "Kërko nxënësin me emër ose mbiemër",
    noUserMatches: "Nuk u gjet asnjë përdorues. Regjistroje fillimisht në listë.",
    linkOnCreateTitle: "Lidhje opsionale",
    linkOnCreateText: "Nëse personi tjetër ekziston në listë, zgjidhe këtu. Nëse jo, mund ta lidhësh më vonë nga rreshti i përdoruesit.",
    relationship: "Lidhja",
    relationshipGuardian: "Kujdestar",
    relationshipParent: "Prind",
    relationshipFather: "Baba",
    relationshipMother: "Nënë",
    relationshipOther: "Tjetër",
    relationshipHelp: "Lidhja aplikohet vetëm për lidhjet e reja. Për babë, nënë dhe kujdestar te i njëjti nxënës, ruaji secilin me lidhjen përkatëse.",
    linkSaved: "Lidhja u ruajt.",
    linkRemoved: "Lidhja u largua.",
    sendInvites: "Dërgo ftesa",
    selectUsersForInvites: "Zgjidh së paku një përdorues para se të dërgosh ftesa.",
    confirmSendInvites: "A dëshiron t'u dërgosh ftesa/udhëzime qasje {count} përdoruesve të selektuar?",
    invitesSent: "U dërguan {count} ftesa.",
    inviteErrors: "ftesa nuk u dërguan.",
    selectAll: "Zgjidh të gjithë",
    selectUser: "Zgjidh përdoruesin",
    guardians: "Prind/Kujdestar",
    linkedStudents: "Nxënësit",
    noGuardiansLinked: "Pa prind/kujdestar",
    noStudentsLinked: "Pa nxënës",
    linkStudent: "Lidh nxënës",
    linkGuardian: "Lidh prind",
    noUsers: "Nuk u gjet asnjë përdorues.",
    name: "Emri dhe mbiemri",
    authMethod: "Metoda",
    accessEvidence: "Qasja",
    lastLogin: "Kyçja e fundit",
    loginCount: "Numri i kyçjeve",
    loginCountValue: "{count} herë",
    neverLoggedIn: "Ende s’është kyçur",
    loginEvidence: "Evidencë",
    loginEvidenceTitle: "Evidenca e kyçjeve",
    loginEvidenceText: "Këtu shihen kyçjet e fundit të suksesshme për këtë përdorues. Numërimi bëhet për Microsoft dhe për email/password.",
    noLoginEvidence: "Nuk ka ende evidencë kyçjeje për këtë përdorues.",
    recentLogin: "Kyçja më e fundit",
    showLoginHistory: "Shfaq historikun e kyçjeve",
    hideLoginHistory: "Fshih historikun",
    status: "Statusi",
    actions: "Veprimet",
    active: "Aktiv",
    inactive: "Joaktiv",
    microsoftShort: "Microsoft",
    passwordShort: "Fjalëkalim",
    save: "Ruaj",
    saving: "Duke ruajtur...",
    cancel: "Anulo",
    createUser: "Krijo përdoruesin",
    newUserTitle: "Përdorues i ri",
    newUserText: "Krijimi vetëm e regjistron përdoruesin. Email-i i ftesës dërgohet më vonë kur e selekton përdoruesin dhe klikon “Dërgo ftesa”.",
    detectedAccessMethod: "Metoda e qasjes",
    microsoftInviteText: "Ky përdorues hyn me Microsoft 365. Nuk i dërgohet link aktivizimi ose fjalëkalimi; ftesa është vetëm njoftim/udhëzim.",
    temporaryPassword: "Fjalëkalimi i përkohshëm",
    temporaryPasswordHint: "Minimum 8 karaktere",
    roleAdmin: "Admin",
    roleAdministration: "Administratë",
    roleSupportStaff: "Staf mbështetës",
    roleProfessor: "Profesor",
    roleCounselor: "Student Adviser",
    roleStudent: "Nxënës",
    roleParent: "Prind",
    roleFoodCompany: "Kompania e ushqimit",
    roleSuperadmin: "Superadmin",
    userCreated: "Përdoruesi u krijua me sukses.",
    userCreatedEmailSent: "Përdoruesi u krijua dhe ftesa u dërgua.",
    userCreatedEmailPending: "Përdoruesi u krijua. Email nuk u dërgua ende; selekto përdoruesin dhe kliko “Dërgo ftesa” kur je gati.",
    userUpdated: "Ndryshimet u ruajtën.",
    resetRequested: "Reset i kërkuar",
    resetPassword: "Cakto fjalëkalim të ri",
    resetPasswordText: "Vendos një fjalëkalim të përkohshëm të fortë me së paku 8 karaktere.",
    newPassword: "Fjalëkalimi i ri",
    loginVisual: "Fotografia e login-it",
    loginVisualText: "Ngarko një fotografi JPG, PNG ose WebP deri në 5 MB. Ndryshimi shfaqet menjëherë për të gjithë.",
    chooseImage: "Zgjidh fotografinë",
    uploadImage: "Publiko fotografinë",
    imageUpdated: "Fotografia e login-it u përditësua.",
    imageRequirements: "Rekomandohet format horizontal, së paku 1600 × 1200 px.",
    orUseLink: "ose përmes lidhjes (URL)",
    useImageLink: "Merr nga lidhja",
    modulesTitle: "Modulet kryesore",
    modulesText: "eduBGT nis me këto pjesë kryesore. Funksionet e secilit modul do t’i shtojmë me radhë.",
    moduleElearningText: "eLearning për materiale, aktivitete dhe mësim online.",
    moduleBtecText: "BTEC për programe, Units dhe evidenca.",
    moduleAssessmentText: "Assessment për vlerësime, rubrika dhe rezultate.",
    moduleInternalInternshipText: "Internal Internship për evidencë dhe ndjekje të progresit.",
    moduleStudentCareText: "Student Wellbeing për mbështetje dhe ndjekje të rasteve.",
    moduleStatus: "Në zhvillim",
    themeLabel: "Zgjedh pamjen",
    themeLight: "Light",
    themeDark: "Dark",
    themeLightTooltip: "Kalo në dritë",
    themeDarkTooltip: "Kalo në errësirë",
    memberTitle: "Hapësira jote po përgatitet",
    memberText: "Qasja jote në eduBGT është aktive. Modulet për rolin tënd do të shtohen në hapat e ardhshëm.",
  },
  en: {
    productName: "eduBGT - Mësimi digjital",
    loginTitle: "Sign in to your account",
    loginSubtitle: "Use the email registered in the platform to continue.",
    email: "Email",
    emailPlaceholder: "example@bgt.school",
    invalidEmail: "Enter a valid email address.",
    checkingAccount: "Checking account...",
    securityCheck: "Security check",
    securityCheckFailed: "The security check could not be completed. Refresh the page and try again.",
    securityUnavailable: "The security check is currently unavailable.",
    accountNotFound: "Account not found. Contact the school for access.",
    accountInactive: "The account is inactive. Contact the school.",
    schoolAccount: "School account",
    schoolAccountText: "You will continue with your Microsoft 365 account.",
    externalAccount: "Authorized account",
    externalAccountText: "Use the password assigned for this account.",
    externalInviteText: "When you select this user and click “Send invites”, an activation link will be sent so they can set their own password.",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot your password?",
    microsoftResetHint: "Reset it through Microsoft",
    requestReset: "Send reset link",
    requestSent: "If the email exists in the platform, a reset link will be sent. Check the inbox.",
    setPasswordTitle: "Set your password",
    setPasswordText: "This is a one-time link. Choose a strong password for your account.",
    setPasswordButton: "Save password",
    setPasswordSuccess: "Your password was saved. You can now sign in.",
    passwordPolicyError: "Password must have at least 8 characters, one uppercase letter, one lowercase letter, one number, one symbol, and no spaces.",
    passwordRulesTitle: "Password must include:",
    passwordRuleMinLength: "At least 8 characters",
    passwordRuleUppercase: "One uppercase letter",
    passwordRuleLowercase: "One lowercase letter",
    passwordRuleNumber: "One number",
    passwordRuleSymbol: "One symbol",
    passwordRuleNoSpaces: "No spaces",
    passwordSymbolsHint: "You can use symbols such as: ! @ # $ % ^ & * ? _ - + = . ,",
    checkingSession: "Checking your session",
    checkingSessionText: "We are verifying whether this link is still active.",
    sessionExpired: "Session expired",
    sessionExpiredText: "This link is no longer active or has already been used. Request a new link to continue.",
    requestAnotherLink: "Go back and request a new link",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match.",
    showPassword: "Show password",
    hidePassword: "Hide password",
    microsoft: "Continue with Microsoft",
    signIn: "Sign in to eduBGT",
    continue: "Continue",
    signingIn: "Signing in...",
    accessOnly: "Access to eduBGT is limited to registered users.",
    contactLink: "Contact the school",
    callbackTitle: "Finishing your sign-in",
    callbackText: "Your account is being securely verified.",
    callbackError: "Sign-in could not be completed",
    retry: "Back to login",
    loading: "Loading...",
    dashboard: "Overview",
    users: "Users",
    userCategories: "User categories",
    staff: "Staff",
    addStaff: "Add staff",
    addParent: "Add parent",
    roles: "Roles",
    studentsNav: "Students",
    studentCare: "Student Wellbeing",
    appearance: "Login appearance",
    collapseSidebar: "Hide menu",
    expandSidebar: "Show menu",
    studentCareModuleName: "Student Wellbeing",
    timetableModuleName: "eLearning",
    timetableTitle: "School timetable",
    timetableSubtitle: "Timetable imported from aSc Timetables — terms 1/2/3, week A/B, days, periods, rooms.",
    timetableImportButton: "Import timetable (aSc XML)",
    timetableClearImported: "Clear imported timetable",
    timetableClearConfirm: "Delete the imported timetable, any pending XML, and XML teachers/students that are still not linked to real users?",
    timetableCleared: "Cleared {count} timetable entries. Accounts kept.",
    timetableRosterCleared: "Removed {teachers} teachers and {students} students from the XML roster that were not linked to real users yet.",
    timetablePendingDiscarded: "Removed {count} pending XML imports that had not been accepted yet.",
    timetableNothingToClear: "There was no imported timetable, XML roster, or pending XML to clear.",
    timetableImported: "Timetable imported: {entries} entries, {terms} new terms, {weeks} new weeks.",
    timetableUnmatchedClasses: "Unmatched classes",
    timetableUnmatchedSubjects: "Unmatched subjects",
    timetableUnmatchedTeachers: "Unmatched teachers",
    timetableNoRows: "The XML contains no timetable entries.",
    timetableEmpty: "No timetable yet. Import an aSc XML file to see it here.",
    timetableTerm: "Term",
    timetableWeek: "Week",
    timetableDay: "Day",
    timetableClass: "Class",
    timetableSubject: "Subject",
    timetableTeacher: "Teacher",
    timetableSlot: "Period",
    timetableCreateAccounts: "Create accounts (those with an email)",
    timetableSendInvites: "Send invites after creation",
    timetableDeactivateMissing: "Deactivate teachers not in this XML",
    timetableImportHint: "Accepts aSc XML or JSON. Creates the roster (classes/subjects/staff/students), the timetable and (optionally) accounts — all here.",
    timetableAccountsCreated: "{count} new accounts",
    timetableInvited: "{count} invites",
    timetableAddManual: "Add lesson manually",
    timetableAddEntry: "Add lesson",
    timetableRoom: "Room",
    timetableEdit: "Edit timetable",
    timetableEditEntry: "Edit lesson",
    timetableActive: "Active",
    timetableSave: "Save lesson",
    timetableEditRoom: "Edit room",
    timetableDuration: "min",
    timetableOnVacation: "Vacation",
    timetableVacationNoSchedule: "The timetable is hidden during vacation.",
    timetableSeed: "Create base terms/weeks",
    timetableSeedHint: "No terms/weeks yet. Create the base structure (Term I–III, Week A/B, Period 1–7) to add lessons manually.",
    timetableDeleteEntry: "Delete lesson",
    timetableTeachers: "Teachers",
    timetableTeachersHint: "Deactivate teachers who have left — their lessons disappear from the timetable without deleting data.",
    timetableNoTeachers: "No teachers in the timetable.",
    timetableLessonsLabel: "lessons",
    timetableStudents: "Students",
    timetableStudentsHint: "Deactivate students who left the school — excluded from the list and exports without deleting data.",
    timetableNoStudents: "No students.",
    timetableRosterAutosave: "Changes save automatically when you tick the box — there is no 'Save' button. Checked = active; unchecked = deactivated.",
    timetableStartDate: "Started",
    timetableEndDate: "Left",
    timetableEnrolledDate: "Enrolled",
    timetableLeftDate: "Left",
    timetableLeaveBlocksLogin: "The leave date blocks platform login (for a student the linked parent is blocked too).",
    classesTitle: "Classes and students",
    classesText: "Classes imported from the timetable. Set the homeroom teacher, view students and transfer them between parallels.",
    classesSchool: "School",
    classesHomeroom: "Homeroom teacher",
    classesNoHomeroom: "No homeroom",
    classesStudentsLabel: "Students",
    classesStudentCount: "{count} students",
    classesTransferTo: "Transfer to",
    classesNoClasses: "No classes. Import the timetable first.",
    classesNoStudents: "No students in this class.",
    classesTransferred: "Student transferred.",
    classesHomeroomSaved: "Homeroom saved.",
    classesHomeroom2: "Homeroom 2",
    classesNoAccount: "no account",
    importSectionTitle: "Import data",
    importSectionText: "Only class teachers are assigned here. Student with parent and staff imports are available under Users in their corresponding tab.",
    importStudentsTitle: "Students + parents",
    importStudentsHint: "Columns: First name; Last name; Class; Email; Gender; Father; Father - Email; Mother; Mother - Email; Legal guardian; Legal guardian - Email.",
    importStaffTitle: "Staff",
    importStaffHint: "Columns: Title; First name; Last name; Gender; Email; Employed from; Employed till (date d/m/yyyy).",
    importClassTeachersTitle: "Class teachers",
    importClassTeachersHint: "Columns: Name/Abbreviation; Class teacher; Class teacher 2. Assigns up to 2 homeroom teachers per class.",
    importChooseCsv: "Choose CSV",
    importStudentsCount: "students",
    importGuardiansCount: "parents stored",
    importLinkedCount: "links",
    importAccountsCount: "new accounts",
    importStaffCount: "staff",
    importBlockedCount: "blocked",
    importAssignedCount: "classes with homeroom",
    importUnmatchedCount: "unmatched",
    genDayMon: "Monday",
    genDayTue: "Tuesday",
    genDayWed: "Wednesday",
    genDayThu: "Thursday",
    genDayFri: "Friday",
    elearningComingSoon: "The school LMS (materials, lessons, assignments) is in development and coming soon.",
    refresh: "Refresh",
    assessmentTitle: "Assessments",
    assessmentSubtitle: "Create tests/quizzes with questions, linked to school subjects and classes.",
    assessmentTitlePlaceholder: "Assessment title",
    assessmentSubject: "Subject",
    assessmentClass: "Class",
    assessmentCreate: "Create assessment",
    assessmentCreated: "Assessment created.",
    assessmentEmpty: "No assessments yet. Create one.",
    assessmentQuestionsLabel: "questions",
    assessmentPointsLabel: "pts",
    assessmentSelectHint: "Select an assessment to manage its questions.",
    assessmentStatusDraft: "Draft",
    assessmentStatusPublished: "Published",
    assessmentStatusClosed: "Closed",
    assessmentDelete: "Delete assessment",
    assessmentDeleteQuestion: "Delete question",
    assessmentPoints: "Points",
    assessmentPromptPlaceholder: "Write the question…",
    assessmentOption: "Option",
    assessmentRemoveOption: "Remove option",
    assessmentAddOption: "Add option",
    assessmentExpectedAnswer: "Expected answer (optional)",
    assessmentAddQuestion: "Add question",
    assessmentQuestionSaved: "Question saved.",
    assessmentTypeSingle: "Single answer",
    assessmentTypeMultiple: "Multiple answers",
    assessmentTypeShort: "Short answer",
    assessmentTypeLong: "Long answer",
    assessmentTake: "Take test",
    assessmentTaking: "Taking",
    assessmentSubmit: "Submit",
    assessmentScore: "Score",
    assessmentResults: "Results",
    assessmentNoResults: "No attempts yet.",
    assessmentStudent: "Student",
    assessmentYourAnswer: "Your answer",
    assessmentClose: "Close",
    studentCareMemberTitle: "Student Wellbeing",
    studentCareMemberText: "Create a new referral and review your submitted referrals list. Confidential details remain locked until the Student Adviser shares them with you.",
    studentCareCounselorText: "Review incoming referrals from teachers, filter cases by urgency, and track the submitted notes for each student.",
    studentCarePrivacyTitle: "Private referral",
    studentCarePrivacyText: "The teacher can view only the submitted referrals list. Confidential details and the case report remain locked until the Student Adviser shares them with you.",
    referralFormTitle: "Support Referral",
    referralFormText: "Complete the required information to refer a student to the Student Adviser.",
    referralBreadcrumbNew: "New referral",
    referralStudent: "Student",
    referralStudentPlaceholder: "Select a student",
    referralGradeClass: "Class",
    referralGradeClassHint: "Fill in the class if it is not available automatically.",
    referralTeacher: "Teacher",
    referralDateTime: "Date and time",
    referralAcademic: "Academic",
    referralSocialEmotional: "Social / Emotional",
    referralNotes: "Additional notes (optional)",
    referralNotesPlaceholder: "Write additional notes about the student situation...",
    referralUrgency: "Urgency",
    referralUrgencyLow: "Low",
    referralUrgencyMedium: "Medium",
    referralUrgencyHigh: "High",
    referralSubmit: "Send referral",
    referralCancel: "Cancel",
    referralSuccess: "The referral was sent successfully. This information is private and accessible only to the Student Adviser.",
    referralConfirmTitle: "Confirm referral submission",
    referralConfirmText: "Do you want to send this referral?",
    referralFormMinimized: "The form is minimized while you review submitted reports.",
    referralStatusChanged: "A report status changed",
    referralNoStudents: "There are no active students to select.",
    referralLoadingStudents: "Loading students...",
    referralValidation: "Select a student, complete the class, and choose at least one referral reason.",
    referralSubmittedTitle: "Submitted reports",
    referralSubmittedText: "Your reports are stored confidentially. You can see the list of referrals you have submitted, but the details remain locked until the Student Adviser shares them with you.",
    referralAccessTitle: "Access submitted reports",
    referralAccessText: "To open submitted reports, continue with Microsoft. Without verification, reports remain locked.",
    referralAccessOpen: "Open reports",
    referralSearchPlaceholder: "Search submitted referrals...",
    referralFilter: "Filter",
    referralFilterAll: "All urgency levels",
    referralColumnDateTime: "Date and time",
    referralColumnStudent: "Student",
    referralColumnClass: "Class",
    referralColumnLevel: "Level",
    referralColumnStatus: "Status",
    referralLockedTitle: "Confidential data",
    referralLockedText: "Details will be shared with you by the Student Adviser.",
    counselorInboxTitle: "Incoming referrals",
    counselorInboxText: "All referrals submitted by teachers for support appear here.",
    counselorStatNew: "New",
    counselorStatReview: "In review",
    counselorStatScheduled: "Scheduled",
    counselorTeacher: "Teacher",
    counselorStudent: "Student",
    counselorReasons: "Reasons",
    counselorReferredBy: "Referred by teacher",
    counselorNotes: "Notes",
    counselorNoNotes: "No additional notes.",
    counselorActions: "Actions",
    counselorDownloadPdf: "Download PDF",
    counselorNotifyParent: "Schedule parent meeting",
    counselorNotifyingParent: "Scheduling...",
    counselorParentNotified: "The parent meeting was scheduled and the parent was notified by email.",
    counselorParentEmailMissing: "Add the parent's email to the student profile.",
    counselorParentMeetingHint: "Set the date and time of the parent meeting.",
    counselorSendParentNotice: "Schedule meeting",
    counselorMarkReview: "Mark as in review",
    counselorAcceptReferral: "Accept referral",
    counselorScheduleMeeting: "Schedule meeting",
    counselorScheduleStudent: "Student",
    counselorScheduleDate: "Date",
    counselorScheduleTime: "Time",
    counselorSaveMeeting: "Schedule meeting",
    counselorMeetingScheduled: "The meeting was scheduled successfully.",
    counselorDirectMeeting: "Schedule meeting",
    counselorDirectMeetingText: "Schedule a meeting directly with a student.",
    counselorSelectStudent: "Select student",
    counselorNotifications: "Notifications",
    counselorNoNotifications: "There are no new notifications.",
    counselorCalendar: "Meeting calendar",
    counselorCalendarYesterday: "Yesterday",
    counselorCalendarToday: "Today",
    counselorCalendarTomorrow: "Tomorrow",
    counselorFullCalendar: "Full calendar",
    counselorFullCalendarTitle: "Monthly meeting calendar",
    counselorFullCalendarHint: "Dotted days have meetings with parents, students or referrals.",
    counselorFullCalendarLegend: "meetings",
    counselorFullCalendarClose: "Close calendar",
    counselorRepeat: "Repeat",
    counselorRecurDays: "Days of week",
    counselorRecurMonths: "For how many months",
    counselorRecurHint: "Pick days and months for a recurring meeting (leave empty for a single meeting).",
    counselorRepeatCreated: "{count} meetings scheduled.",
    counselorRepeatPartial: "{created} meetings scheduled; {skipped} skipped (time taken).",
    advisoryTitle: "Report to teachers",
    advisoryHint: "Send a report to all teachers about a student (e.g. the areas where they are more sensitive).",
    advisoryReasons: "Reasons",
    advisoryContentPlaceholder: "Write the report for teachers (e.g. the student is more sensitive about...)",
    advisorySend: "Send report",
    advisorySending: "Sending...",
    advisorySent: "Report sent to teachers.",
    advisoryListTitle: "Sent reports",
    advisoryEmpty: "You haven't sent any reports yet.",
    advisoryDelete: "Delete",
    advisoryConfirmDelete: "Delete this report?",
    professorAdvisoriesTitle: "Reports from the counselor",
    professorAdvisoriesHint: "Reports from the school counselor about students.",
    professorAdvisoriesEmpty: "No reports from the counselor.",
    advisoryFrom: "From",
    intakeTitle: "New students",
    intakeHint: "Save reports for students who will start school (before they are enrolled in the system).",
    intakeStudentName: "Student name",
    intakeStudentNamePlaceholder: "First and last name",
    intakeGradeClass: "Class (optional)",
    intakeContentPlaceholder: "Write the report for the new student...",
    intakeSave: "Save report",
    intakeSaving: "Saving...",
    intakeSaved: "Report saved.",
    intakeListTitle: "Saved reports",
    intakeEmpty: "You haven't saved any reports yet.",
    intakeViewReport: "View report",
    intakeHideReport: "Hide report",
    intakeConfirmDelete: "Delete this report?",
    counselorMeetingWith: "Meeting with",
    counselorMeetingTypeStudent: "Meeting with student",
    counselorMeetingTypeParent: "Meeting with parent",
    counselorMeetingParentOf: "Parent of",
    counselorMeetingParentUnknown: "Parent (name not on file)",
    counselorNoAppointments: "There are no meetings for this date.",
    counselorNextAppointment: "Next appointment",
    counselorNoUpcomingAppointment: "There is no upcoming appointment.",
    counselorThisMonth: "This month",
    counselorCompletedCases: "Completed",
    counselorHighPriority: "High priority",
    counselorReschedule: "Reschedule",
    counselorCancelMeeting: "Cancel meeting",
    counselorPrivateNotes: "Private notes",
    counselorPrivateNotesHint: "Only you can view these notes.",
    counselorAddNote: "Add note",
    counselorHistory: "Case history",
    counselorStatusFilter: "All statuses",
    counselorClassFilter: "All classes",
    counselorCloseReferral: "Close referral",
    counselorCompleteReferral: "Mark as completed",
    counselorCompleteMessageHint: "Leave a message for the professor who sent the referral (optional).",
    counselorCompleteMessagePlaceholder: "Message for the professor…",
    counselorCompleteAndSend: "Complete and send",
    professorCounselorMessage: "Message from the school psychologist",
    counselorNewReferral: "New referral",
    counselorTodayReferrals: "Today's referrals",
    counselorOldReferrals: "Older referrals",
    counselorFilterDate: "Search by date",
    referralStatusSent: "Sent",
    referralStatusPending: "Pending",
    referralStatusInReview: "In review",
    referralStatusShared: "Shared",
    referralStatusClosed: "Closed",
    referralStatusCompleted: "Completed",
    referralNoResults: "No referrals have been submitted yet.",
    welcome: "Welcome",
    workspaceText: "Manage access, roles and the visual identity of eduBGT.",
    role: "Role",
    logout: "Sign out",
    sessionSecurity: "Session security",
    loginSessionExpired: "Your session expired to protect your account. Sign in again to continue.",
    sessionExpiresSoon: "Your session will expire soon",
    sessionExpiresSoonText: "No activity has been detected for 25 minutes. Continue within 5 minutes or you will automatically return to sign in.",
    continueSession: "Continue session",
    totalUsers: "Total users",
    activeUsers: "Active accounts",
    admins: "Admins",
    professors: "Professors",
    students: "Students",
    parents: "Parents",
    accessOverview: "eduBGT access",
    accessOverviewText: "Every user is pre-registered. @bgt.school emails use Microsoft; other domains use a password.",
    microsoftAccess: "Microsoft 365",
    passwordAccess: "Email + password",
    protectedAccess: "Controlled access",
    userDirectory: "User directory",
    userDirectoryText: "Manage staff, students and parents in one place. A user can have multiple roles.",
    studentDirectory: "Student directory",
    studentDirectoryText: "Store the basic students that teachers can select in Student Wellbeing referrals.",
    parentEmail: "Parent email",
    parentEmailPlaceholder: "parent@example.com",
    saveParentEmail: "Save parent email",
    parentEmailSaved: "The parent email was saved.",
    parentName: "Parent name",
    parentNamePlaceholder: "Parent's full name",
    parentNameSaved: "The parent name was saved.",
    gradeClass: "Class",
    subjectsTaught: "Subjects",
    addStudent: "Add student",
    createStudent: "Create student",
    newStudentTitle: "New student",
    newStudentText: "Save the student's first name, last name, and email so it can be used in referrals.",
    firstName: "First name",
    lastName: "Last name",
    noStudentsSaved: "No students have been saved yet.",
    studentCreated: "The student was created successfully.",
    accessPolicyTitle: "Access rule",
    accessPolicyText: "Sign-in is allowed only for accounts that exist here and are active.",
    accessPolicyMicrosoft: "@bgt.school uses Microsoft 365 after being registered in the dashboard.",
    accessPolicyLocal: "Other domains receive an activation link and use a local password.",
    accessPolicyActive: "Inactive accounts and unregistered emails are rejected before sign-in.",
    searchUsers: "Search by name or email",
    addUser: "Add user",
    importUsers: "Import",
    importUsersTitle: "Import users and eLearning data",
    importUsersText: "Import only accounts with email (CSV/Excel) here. Import the timetable (aSc XML) under Settings → Timetable.",
    usersImportHint: "Import only accounts with email (CSV/Excel) here. Import the timetable (XML) under Settings → Timetable.",
    chooseImportFile: "Choose CSV or Excel",
    importContent: "Import content",
    importPlaceholder: "CSV/Excel: first_name,last_name,email,children",
    csvImportMode: "CSV/Excel for parents or users",
    xmlImportMode: "XML staging for eLearning",
    csvImportHelp: "CSV/Excel creates only first name, last name and email. The Children column can be used for automatic or pending links with students from XML.",
    xmlImportHelp: "XML stores students, classes, teachers, subjects and timetable for eLearning. If the option below is enabled, it also creates global accounts for students/teachers that have an email (those without an email are kept only in the roster — to assign emails later, download the list below, fill in the emails and re-import as CSV). The <users> export format is also accepted.",
    xmlStatsLine: "XML: {students} students, {teachers} teachers, {classes} classes, {subjects} subjects were saved for eLearning.",
    createAccountsFromXml: "Create accounts from XML (those with an email)",
    rosterPendingTitle: "No account (from timetable)",
    rosterPendingHint: "Teachers/students from the timetable without an account. Download the list, fill emails, upload it back or register manually. For students, the list also has father/mother/guardian columns (+ gender) — fill the student's and parent's email in the same row and they link automatically on upload. This import also accepts EduPage's CSV export directly (First name/Last name/Class/Father - Gender/etc.) — you can upload it as-is, no reformatting needed.",
    rosterTeacher: "Teacher",
    rosterStudent: "Student",
    rosterSendInviteWhenEmail: "Send invite (when email exists)",
    rosterSendInviteGuardians: "Also send invite to parents/guardians (separate from students)",
    rosterSearchName: "Search name",
    rosterRoleAll: "All",
    rosterRoleTeachers: "Teachers",
    rosterRoleStudents: "Students",
    rosterEmailAll: "All",
    rosterOnlyWithEmail: "Only with email",
    rosterSendInvitesCount: "Send invites ({count})",
    rosterEmptyFilter: "No people for this filter.",
    rosterRegistered: "{name} registered.",
    rosterAlreadyExisted: "{name} already had an account — linked to the roster (no new account created).",
    rosterBulkExisting: "({existing} already had accounts, linked.)",
    rosterBulkRegistered: "Registered {registered}.",
    rosterBulkRegisteredInvited: "Registered {registered}, sent {invited} invites.",
    rosterRegister: "Register",
    rosterManageAtUsers: "Accounts are managed under Users → No account (from timetable).",
    rosterDownloadExcel: "Download Excel",
    rosterUploadFilled: "Upload completed Excel",
    rosterFillResult: "Matched {matched}, created {created}, sent {invited} invites.",
    rosterFillGuardianNote: "Parents: {stored} stored, {linked} linked automatically to students.",
    rosterUploadProcessing: "Processing rows, don't close the page — this can take a few dozen seconds for many rows.",
    uploadInProgress: "Uploading and processing the file, don't close the page…",
    rosterUnmatched: "Unmatched",
    rosterSuspiciousNames: "Suspicious parent names (numbers instead of a name — check the source CSV)",
    rosterSelectAll: "Select all",
    rosterRegisterSelected: "Register selected ({count})",
    rosterFilterClass: "Filter class",
    rosterFilterRole: "Filter role",
    rosterOnlyNoEmail: "Only without email",
    exportUsers: "Export",
    rosterNeedEmail: "Enter email",
    downloadRosterTemplate: "Download roster (no account)",
    rosterTemplateHelp: "Download all students/teachers from the timetable that don't have an account yet (existing emails come pre-filled), fill in any that are missing in Excel, then re-import as CSV (with 'Send invites') to create and invite the accounts.",
    sendInvitesAfterImport: "Send invites/access instructions after import",
    importCompleted: "Import completed",
    createdShort: "created",
    updatedShort: "updated",
    linkedShort: "links",
    pendingShort: "pending",
    stagedShort: "staged",
    invitedShort: "invites",
    skippedShort: "skipped",
    invitePolicyTitle: "How invitations work",
    invitePolicyText: "Creating a user only registers them in the platform. Email is sent only when you select the user and click “Send invites”, or when you enable the checkbox during import.",
    invitePolicyAutomatic: "Manual creation does not send email automatically.",
    invitePolicyMicrosoft: "@bgt.school users do not receive an activation/password link; they receive an information email and sign in with Microsoft.",
    invitePolicyLocal: "External email domains receive a link to create their password.",
    invitePolicySelection: "The “Send invites” button works only for selected users.",
    allUsers: "All",
    linkParentStudent: "Link parent-student",
    linkParentStudentText: "Use search and table selection for large lists. You can link one parent to multiple students, or one student to multiple parents/guardians.",
    linkModeParentToStudents: "Parent → students",
    linkModeStudentToParents: "Student → parents",
    linkDialogHint: "For 300+ users, do not scan the list manually; search by first name, last name, or email and select the rows that should be linked.",
    chooseParentFirst: "Choose parent / guardian",
    chooseStudentFirst: "Choose student",
    selectStudentsToLink: "Select students",
    selectParentsToLink: "Select parents / guardians",
    linkedCount: "Links",
    selectedCount: "{count} selected",
    showingCount: "{shown} of {total}",
    alreadyLinked: "Linked",
    newLinkLabel: "New",
    readyLinks: "New links to save",
    saveLinks: "Save links",
    linksSaved: "{count} links were saved.",
    noNewLinks: "Choose at least one new link.",
    selectParentAndStudents: "Choose one parent/guardian and at least one student.",
    selectStudentAndParents: "Choose one student and at least one parent/guardian.",
    parentGuardianEmail: "Parent / guardian",
    studentEmail: "Student",
    searchParentGuardian: "Search parent by first or last name",
    searchStudent: "Search student by first or last name",
    noUserMatches: "No users found. Register the person in the list first.",
    linkOnCreateTitle: "Optional link",
    linkOnCreateText: "If the other person already exists, select them here. Otherwise, you can link them later from the user row.",
    relationship: "Relationship",
    relationshipGuardian: "Guardian",
    relationshipParent: "Parent",
    relationshipFather: "Father",
    relationshipMother: "Mother",
    relationshipOther: "Other",
    relationshipHelp: "The relationship applies only to new links. For father, mother, and guardian on the same student, save each with the correct relationship.",
    linkSaved: "The link was saved.",
    linkRemoved: "The link was removed.",
    sendInvites: "Send invites",
    selectUsersForInvites: "Select at least one user before sending invites.",
    confirmSendInvites: "Send invites/access instructions to {count} selected users?",
    invitesSent: "{count} invites were sent.",
    inviteErrors: "invites were not sent.",
    selectAll: "Select all",
    selectUser: "Select user",
    guardians: "Parent/guardian",
    linkedStudents: "Students",
    noGuardiansLinked: "No parent/guardian",
    noStudentsLinked: "No students",
    linkStudent: "Link student",
    linkGuardian: "Link guardian",
    noUsers: "No users found.",
    name: "Full name",
    authMethod: "Method",
    accessEvidence: "Access",
    lastLogin: "Last sign-in",
    loginCount: "Sign-in count",
    loginCountValue: "{count} times",
    neverLoggedIn: "Not signed in yet",
    loginEvidence: "Evidence",
    loginEvidenceTitle: "Sign-in evidence",
    loginEvidenceText: "This shows the latest successful sign-ins for this user. Counts include Microsoft and email/password sign-ins.",
    noLoginEvidence: "There is no sign-in evidence for this user yet.",
    recentLogin: "Most recent sign-in",
    showLoginHistory: "Show sign-in history",
    hideLoginHistory: "Hide history",
    status: "Status",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    microsoftShort: "Microsoft",
    passwordShort: "Password",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    createUser: "Create user",
    newUserTitle: "New user",
    newUserText: "Creating a user only registers them. The invitation email is sent later when you select the user and click “Send invites”.",
    detectedAccessMethod: "Access method",
    microsoftInviteText: "This user signs in with Microsoft 365. No activation or password link is sent; the invite is only an information email.",
    temporaryPassword: "Temporary password",
    temporaryPasswordHint: "Minimum 8 characters",
    roleAdmin: "Admin",
    roleAdministration: "Administration",
    roleSupportStaff: "Support staff",
    roleProfessor: "Professor",
    roleCounselor: "Student Adviser",
    roleStudent: "Student",
    roleParent: "Parent",
    roleFoodCompany: "Food company",
    roleSuperadmin: "Superadmin",
    userCreated: "The user was created successfully.",
    userCreatedEmailSent: "The user was created and the invite was sent.",
    userCreatedEmailPending: "The user was created. No email was sent yet; select the user and click “Send invites” when ready.",
    userUpdated: "Changes were saved.",
    resetRequested: "Reset requested",
    resetPassword: "Set a new password",
    resetPasswordText: "Set a strong temporary password with at least 8 characters.",
    newPassword: "New password",
    loginVisual: "Login image",
    loginVisualText: "Upload a JPG, PNG or WebP image up to 5 MB. The change appears immediately for everyone.",
    chooseImage: "Choose image",
    uploadImage: "Publish image",
    imageUpdated: "The login image was updated.",
    imageRequirements: "A horizontal image of at least 1600 × 1200 px is recommended.",
    orUseLink: "or via a link (URL)",
    useImageLink: "Fetch from link",
    modulesTitle: "Core modules",
    modulesText: "eduBGT starts with these core areas. Each module will be expanded step by step.",
    moduleElearningText: "Online learning, materials and digital activities.",
    moduleBtecText: "BTEC programme, unit and evidence management.",
    moduleAssessmentText: "Structured assessment, rubrics and results.",
    moduleInternalInternshipText: "Internal internship planning, records and progress tracking.",
    moduleStudentCareText: "Student wellbeing, support, and case follow-up.",
    moduleStatus: "In development",
    themeLabel: "Choose appearance",
    themeLight: "Light",
    themeDark: "Dark",
    themeLightTooltip: "Switch to light mode",
    themeDarkTooltip: "Switch to dark mode",
    memberTitle: "Your workspace is being prepared",
    memberText: "Your eduBGT access is active. Modules for your role will be added in the next steps.",
  },
} as const;

export function platformModules(locale: Locale) {
  const t = translations[locale];
  return [
    { title: "eLearning", text: t.moduleElearningText },
    { title: "BTEC", text: t.moduleBtecText },
    { title: "Assessment", text: t.moduleAssessmentText },
    { title: "Internal Internship", text: t.moduleInternalInternshipText },
    { title: t.studentCareModuleName, text: t.moduleStudentCareText },
  ];
}

export function roleLabel(role: ApiRole, locale: Locale) {
  const t = translations[locale];
  const labels: Record<ApiRole, string> = {
    superadmin: t.roleSuperadmin,
    admin: t.roleAdmin,
    administration: t.roleAdministration,
    support_staff: t.roleSupportStaff,
    professor: t.roleProfessor,
    student_adviser: t.roleCounselor,
    counselor: t.roleCounselor,
    student: t.roleStudent,
    parent: t.roleParent,
    food_company: t.roleFoodCompany,
  };
  return labels[role];
}

export const localeChangeEvent = "edubgt:locale-change";

export function readLocale(): Locale {
  return browserLocalStorage.getItem("edubgt_locale") === "en" ? "en" : "sq";
}

export function saveLocale(locale: Locale) {
  browserLocalStorage.setItem("edubgt_locale", locale);
  if (typeof window !== "undefined") window.dispatchEvent(new Event(localeChangeEvent));
}

/** Translate application copy only; authored content keeps its original language. */
export function translateUi(sq: string, en: string, locale: Locale = readLocale()): string {
  return locale === "en" ? en : sq;
}
